import type { MailboxInfo } from 'owa-client-types';
import { isAccountExplicitLogon } from 'owa-account-shared-mailbox-utils';
import {
    getIsBitSet,
    type FolderPaneBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/folderPaneBitFlagsUtil';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

export const getIsCustomSortEnabled = (mailboxInfo: MailboxInfo): boolean => {
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        // Custom sort is not supported for unified inbox
        return false;
    }

    const isExplicitLogon = isAccountExplicitLogon(mailboxInfo);
    const isBitSet = getIsBitSet(1, mailboxInfo);
    return !isExplicitLogon && !isBitSet;
};
